import api from 'utils/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contentexpress/merchandiseOrderItem/FETCH_REQUEST'
const FETCH_SUCCESS = 'contentexpress/merchandiseOrderItem/FETCH_SUCCESS'
const FETCH_FAILURE = 'contentexpress/merchandiseOrderItem/FETCH_FAILURE'

// Initial State
const initialState = {
  errors: [],
  loaded: false,
  loading: false,
  result: {},
}

// Actions
export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadMerchandiseOrderItem(id, options) {
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api(`/merchandises/${id}/orderitem`, options)
      .then(({ data }) => {
        //This is not included on return at the moment but needed so we can check when we don't need to load this
        data.merchandiseId = id

        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        result: payload,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    default:
      return state
  }
}
